import service from '@/store/services/employers/tariff-service';
import activityTariffService from '@/store/services/employers/tariff-activity-service';

const state = {
    list: {},
    tariff: {},
    tariffActivity: {},
    meta: {}
};

const mutations = {
    SET_LIST: (state, list) => {
        state.list = list;
    },
    SET_RESOURCE: (state, tariff) => {
        state.tariff = tariff;
    },
    SET_META: (state, meta) => {
        state.meta = meta;
    }

};

const actions = {
    list ({ commit, dispatch }, params = {}) {
        return service.list(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },
    activities ({ commit, dispatch }, params) {
        return service.activities(params)
            .then(({ list, meta }) => {
                commit('SET_LIST', list);
                commit('SET_META', meta);
            });
    },

    // get ({ commit, dispatch }, params) {
    //     return service.get(params)
    //         .then(tariff => {
    //             commit('SET_RESOURCE', tariff);
    //         });
    // },
    get({ commit }, payload) {
        // payload contains { id, include, ... }
        return service.get(payload)
            .then(tariff => {
                commit('SET_RESOURCE', tariff);
            });
    },
    rates ({ commit, dispatch }, params) {
        return activityTariffService.list(params)
            .then(tariffActivity => {
                commit('SET_RESOURCE', tariffActivity);
            });
    },
    show ({ commit, dispatch }, params) {
        return service.show(params)
            .then(tariff => {
                commit('SET_RESOURCE', tariff);
            });
    },
    add ({ commit, dispatch }, params) {
        return service.add(params)
            .then((tariff) => {
                commit('SET_RESOURCE', tariff);
            });
    },

    update ({ commit, dispatch }, params) {
        return service.update(params)
            .then((tariff) => {
                commit('SET_RESOURCE', tariff);
            });
    },

    destroy ({ commit, dispatch }, params) {
        return service.destroy(params);
    },
};

const getters = {
    list: state => state.list,
    listTotal: state => state.meta.page.total,
    tariff: state => state.tariff,
    tariffActivity: state=> state.tariffActivity,
    activities: state => state.activities,
    dropdown: (state) => {
        return state.list.map(tariff => ({
            id: tariff.id,
            name: tariff.name
        }));
    }
};

const tariffs = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default tariffs;
